import { IFilterConfig } from '@df/catalog-ui/listing/filter/filter';
import { FilterAttributeOption } from '@df/catalog-ui/listing/filter/filter-attribute-option';
import { IMatchesCounts } from '@df/catalog-ui/listing/filter/filter-property';
import { ListingFilter } from '@df/catalog-ui/listing/listing';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { IProductDataV2 } from '@df/catalog/product/product';
import { NgInject } from '@df/ng/ng-inject';
import { KlevuSearchService } from 'projects/app-default/src/app/module/klevu-search/klevu-search.service.decorator';
import { Product } from '../../../product/product.decorator';

@ListingFilter({
    filterType: 'attribute-option'
})
export class LocalFilterAttributeOption<
    TModel extends Product<IProductDataV2>,
    TOption = Catalog.IAttributeOption | Catalog.IAttributeOptionGroup,
    TConfig extends IFilterConfig<string> = IFilterConfig<string>
> extends FilterAttributeOption<TModel, TOption, TConfig> {
    @NgInject(KlevuSearchService)
    klevuSearchService!: KlevuSearchService;

    override get matchesCountsCurrent(): IMatchesCounts {
        const sourceModel = this.listing.config.source;
        const excludedItemsCache = this.klevuSearchService.excludedItemsCache[sourceModel.id];

        if (!this._matchesCountsCurrent) {
            const matches: IMatchesCounts = {};
            this.options.forEach(option => {
                const selectionValue = this.optionToId(option);
                const filteredModelsExceptFilter = this.listing.getFilteredModelsExceptFilter([
                    { filter: this, selection: [selectionValue] }])?.filter((product: Product<IProductDataV2>) => {
                        return !excludedItemsCache?.excludedItems.includes(product.id) &&
                        !excludedItemsCache?.excludedParents.includes(product.parent.id);
                    }
                );
                matches[selectionValue] = filteredModelsExceptFilter?.length;
            });
            this._matchesCountsCurrent = matches;
        }
        return this._matchesCountsCurrent;
    }
}
